import { generateId } from '@freelancer/datastore/testing/helpers';
import type { AiEscalationSourceType } from './ai-escalation.backend-model';
import type { AiEscalation } from './ai-escalation.model';

export interface GenerateAiEscalationOptions {
  readonly id?: number;
  readonly escalationCategory?: string;
  readonly escalationReason: string;
  readonly sourceType: AiEscalationSourceType;
  readonly sourceId: number;
  readonly createdAt?: number;
  readonly resolvedAt?: number;
}

export function generateAiEscalationObject({
  id = generateId(),
  escalationCategory,
  escalationReason,
  sourceType,
  sourceId = generateId(),
  createdAt = Date.now(),
  resolvedAt,
}: GenerateAiEscalationOptions): AiEscalation {
  return {
    id,
    escalationCategory: escalationCategory ?? undefined,
    escalationReason,
    sourceType,
    sourceId,
    createdAt,
    resolvedAt: resolvedAt ?? undefined,
  };
}

export function generateAiEscalationObjects(
  aiEscalations: readonly AiEscalation[],
): readonly AiEscalation[] {
  return [...aiEscalations];
}
